import type { AiService } from '@/context/services/ai_service_setting/type';
import { useTranslation } from '@/i18n';
import { Caption, TextLink } from '@moneyforward/ap-frontend-components';
import { FC, PropsWithChildren } from 'react';

type Props = {
  service: AiService;
};

export const ServiceContent: FC<PropsWithChildren<Props>> = ({
  service,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {children}
      <Caption icon={false} type='helper'>
        {service.description}
        {service.detail_url && (
          <TextLink href={service.detail_url} target='_blank'>
            {t('ai_service_setting.details_link')}
          </TextLink>
        )}
      </Caption>
    </>
  );
};

ServiceContent.displayName = 'ApAiServiceSettingsServiceContent';
